import axios from 'axios';
import axiosRetry from 'axios-retry';

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 250;
  },
  // Add this to prevent retrying on 4xx errors
  retryCondition: (error) => {
    return !error.response || error.response.status >= 500;
  },
});
